import { STATUSES } from '@/constants/common/message.constants'

/**
 * タリフのインポートステータス
 */
export const TARIFF_IMPORT_JOB_STATUS_TYPE = {
  PENDING: 'PENDING',
  IMPORTING: 'IMPORTING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR'
} as const

/**
 * タリフのインポートステータスのラベル
 */
export const TARIFF_IMPORT_JOB_STATUS_TYPE_LABEL = {
  [TARIFF_IMPORT_JOB_STATUS_TYPE.PENDING]: STATUSES.PENDING,
  [TARIFF_IMPORT_JOB_STATUS_TYPE.IMPORTING]: STATUSES.IMPORTING,
  [TARIFF_IMPORT_JOB_STATUS_TYPE.COMPLETED]: STATUSES.COMPLETED,
  [TARIFF_IMPORT_JOB_STATUS_TYPE.ERROR]: STATUSES.FAILED
} as const

export type TariffImportJobStatusType =
  (typeof TARIFF_IMPORT_JOB_STATUS_TYPE)[keyof typeof TARIFF_IMPORT_JOB_STATUS_TYPE]
